import React, { useEffect, useRef, useState } from 'react'
import { confirm } from 'react-confirm-box'
import { useDispatch, useSelector } from 'react-redux'
import {
  getOurTemplateList,
  getAllCategoryList,
  getOurTemplate,
  GetAllCategory,
} from '../../../MyTemplate/OurTemplates/OurTemplateSlice/OurTemplateSlice'
import TemplatePreviewPopup from '../Modal/TemplatePreviewPopup'
import {
  getAllTemplate,
  getTemplateList,
  getTemplateListWithoutPagination,
} from '../../../MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'
import {
  BulkMsgDraftData,
  GetSavedCampaigsList,
  getAllPreviouslySendCampaignsList,
  getAllSavedCampaignsList,
} from '../../BulkMessageSlice/BulkMessageSlice'
import ConfirmationModel from '../../../../../Components/ConfirmationModel'
import { bulkMessageState } from '../NewMessageStepper'
import Select from 'react-select'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { processLinks } from '../../../../../Utils/_helpers'
import { ENV } from '../../../../../Utils/_helpers/EnvHelper'
import { useNewMessage } from '../../useNewMessage'
import { getDefaultOptOutUrl } from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import moment from 'moment-timezone'

const GettingStarted = ({
  setBulkMessageData,
  bulkMessageData,
  FirstDiv,
  show,
  error,
  setError,
  validation,
  checkStep,
}: any) => {
  const dispatch = useDispatch()
  ////////////COnfirmation state//////////////////
  const [confirmationPopup, setConfirmationPopup] = useState(false)
  const [message, setMessage] = useState('')
  const [allow, setAllow] = useState(false)
  ////////////////////////////////////////////////
  const [visible, setVisble] = useState(false)
  const [showTemplate, setShowTemplate] = useState(false)
  // const [savedCampaignsId, setSavedCampaignsId] = useState()
  const [activeTab, setActiveTab] = useState('newCamp')
  const [filterName, setFilterName] = useState<any>({ type: 'MMS' })
  const [templateData, setTemplateData] = useState({})
  const Templates: [] = useSelector(getOurTemplateList)
  const Category = useSelector(getAllCategoryList)
  // const templates: any = useSelector(getTemplateList)
  const templates: any = useSelector(getTemplateListWithoutPagination)
  const SavedCampaignList = useSelector(getAllSavedCampaignsList)
  const PreviouslySendCampagin = useSelector(getAllPreviouslySendCampaignsList)
  const { isDefaultRegion } = useNewMessage();
  const optOutBaseUrl = useSelector(getDefaultOptOutUrl)


  const MMSList = Templates?.filter((key: any) => key?.type == 'MMS')
  const SMSList = Templates?.filter((key: any) => key?.type == 'SMS')
  const selectTemplateRef: any = useRef()
  useEffect(() => {
    dispatch(getOurTemplate(filterName))
  }, [filterName])
  useEffect(() => {
    if (allow == true) {
      setBulkMessageData(bulkMessageState)
      setAllow(false)
      setError({})
    } else {
      // if (
      //   bulkMessageData?.name !== '' &&
      //   bulkMessageData?.previouslySendId == '' &&
      //   bulkMessageData?.saveCampaignId == ''
      // ) {
      //   newCampref?.current.click()
      // } else {
      //   savedCampref?.current.click()
      // }
    }
  }, [allow])

  const cleanOptOutFromMessage = (message: string) => {
    let pattern = optOutBaseUrl
    if (!pattern) {
      return message
    }

    // Create a regular expression pattern dynamically
    const urlPattern = new RegExp(`${pattern}/\\S*`, 'g')

    // Remove the matching URL
    let cleanedMessage = message.replace(urlPattern, '')

    // Remove double (or more) line breaks
    cleanedMessage = cleanedMessage.replace(/\n{2,}/g, '\n')

    // Trim any leading or trailing whitespace or line breaks

    return cleanedMessage.trim()
  }

  const decodeLandingPageUrl = (message: string) => {
    let pattern = ENV().REACT_APP_SHORTURL
    if (!pattern) {
      return message
    }

    // Define a regular expression to match URLs in the format 'dev.gosite.au/luvg1aE'
    const urlPattern = new RegExp(`(${pattern}/l\\w*)`, 'g')

    // Replace matched URL codes that start with "l" with "Lxxxxx"
    const cleanedMessage = message.replace(urlPattern, `${pattern}/Lxxxxx`)

    return cleanedMessage
  }

  const handleSavedCampaign = async (e: any) => {
    let val = e.value
    let foundData = await SavedCampaignList?.data?.items?.find((key: any) => key?._id === val)

    if (foundData && val !== '') {
      const name = { ...foundData }
      if (name) {
        if (name && name.optout && name.optout === true) {
          name.message = name.message.replace(`\nSTOP: ${optOutBaseUrl}/vc`, '')
          name.message = cleanOptOutFromMessage(name.message)
        }

        if (name && name.replyStopToOptOut && name.replyStopToOptOut === true) {
          name.message = name.message.replace("\nReply 'STOP' to opt-out", '')
        }

        setBulkMessageData({
          ...name,
          saveCampaignId: e,
          media: name?.media?.url,
          urlData: name?.media,
          senderType: name?.senderType ? name?.senderType : '',
          sender: name?.sender
            ? { value: name?.sender, label: `${name?.sender}-${name?.camp_type?.toUpperCase()}` }
            : '',
          selectedTemplate: { value: '', label: 'Select Template' },
          message: processLinks(name?.message),
        })
        setError({})
        // validation({saveCampaignId: val, ...name})
      } else {
        setBulkMessageData(bulkMessageState)
        setError({})
      }
    } else {
      let val = e.value
      let data = [...PreviouslySendCampagin?.data?.sms, ...PreviouslySendCampagin?.data?.mms]?.find(
        (key: any) => key?._id === val
      )

      let cleanMessage = cleanOptOutFromMessage(processLinks(data?.message))
      if (data?.landingPageId && data?.landingPageId !== "") {
        cleanMessage = decodeLandingPageUrl(cleanMessage)
      }
      setBulkMessageData({
        ...data,
        media: data?.media?.[0]?.url,
        urlData: data?.media?.[0],
        previouslySendId: e,
        senderType: data?.senderType ? data?.senderType : '',
        sender: data?.sender
          ? data?.senderType == '#SharedNum#'
            ? { value: '#SharedNum#', label: '#SharedNum#' }
            : { value: data?.sender, label: data?.sender }
          : '',
        selectedTemplate: { value: '', label: 'Select Template' },
        message: cleanMessage,
      })
    }
  }
  const handleSelectTemplate = (e: any) => {
    const preveiousTemplate = templates?.find((key: any) => key.name == e.value)
    setBulkMessageData({
      ...bulkMessageData,
      message: preveiousTemplate.message,
      camp_type: preveiousTemplate.type?.toLowerCase(),
      media: preveiousTemplate.media,
      gif: preveiousTemplate.gif,
      subject: preveiousTemplate.subjectTitle,
      selectedTemplate: e,
    })
  }

  const SavedCampaginList = () => {
    let options = []

    if (PreviouslySendCampagin?.data?.sms?.length > 0) {
      const smsOptions = PreviouslySendCampagin.data.sms.map((key: any) => ({
        value: key._id,
        label: `${key.name} - ${moment(key?.createdAt).format('DD/MM/YYYY')}`,
      }))

      options.push({
        label: 'PREVIOUSLY SENT SMS',
        options: smsOptions,
      })
    }

    if (PreviouslySendCampagin?.data?.mms?.length > 0) {
      const mmsOptions = PreviouslySendCampagin.data.mms.map((key: any) => ({
        value: key._id,
        label: `${key.name} - ${moment(key?.createdAt).format('DD/MM/YYYY')}`,
      }))

      options.push({
        label: 'PREVIOUSLY SENT MMS',
        options: mmsOptions,
      })
    }

    if (SavedCampaignList?.data?.items?.length > 0) {
      const savedOptions = SavedCampaignList.data.items.map((key: any) => ({
        value: key._id,
        label: `${key.name} - ${moment(key?.createdAt).format('DD/MM/YYYY')}`,
      }))

      options.push({
        label: 'SAVED',
        options: savedOptions,
      })
    }

    return options
  }

  const optionsWithLabelChange = {
    closeOnOverlayClick: false,
    labels: {
      confirmable: 'Confirm',
      cancellable: 'Cancel',
    },
  }

  return (
    <>
      <ConfirmationModel
        show={confirmationPopup}
        handleClose={() => setConfirmationPopup(false)}
        message={message}
        setAllow={setAllow}
      />
      <TemplatePreviewPopup
        show={visible}
        handleClose={() => setVisble(false)}
        templateData={templateData}
        setBulkMessageData={setBulkMessageData}
        bulkMessageData={bulkMessageData}
      />
      <h2
        className={`accordion-header ${bulkMessageData.name !== '' && 'successData'}`}
        id='headingOne'
      >
        <button
          ref={FirstDiv}
          className='accordion-button successComplete'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseOne'
          aria-expanded='true'
          aria-controls='collapseOne'
        >
          Getting started
        </button>
        <div className='bulk-message-collapse'>
          <div className='accordion-title-detail small' data-testid='txtNewCampaign'>
            New campaign
          </div>

          {/* <button
            type='button'
            className=' btn-toggle-bulk'
            data-bs-toggle='collapse'
            data-bs-target='#collapseOne'
            aria-expanded='true'
            aria-controls='collapseOne'
          >
            Click
          </button> */}
        </div>
      </h2>
      <div
        id='collapseOne'
        className={`accordion-collapse collapse  ${checkStep.gettingStarted && 'show'}`}
        aria-labelledby='headingOne'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <ul className='nav nav-tabs' id='myTab' role='tablist'>
            <li className='nav-item me-3 mb-3' role='presentation'>
              <button
                className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${activeTab == 'newCamp' ? 'active' : ''
                  }`}
                data-testid='btnNewCampaign'
                onClick={async () => {
                  if (bulkMessageData?.name !== '') {
                    let confirNew = await confirm(
                      'Are you sure you want to create a new campaign?',
                      optionsWithLabelChange
                    )

                    if (confirNew) {
                      setBulkMessageData(bulkMessageState)
                      setError({})
                      setActiveTab('newCamp')
                    } else {
                      setActiveTab('pervCamp')
                    }
                  } else {
                    setActiveTab('newCamp')
                  }
                }}
              >
                New campaign
              </button>
            </li>
            <li className='nav-item me-3 mb-3' role='presentation'>
              <button
                className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${activeTab == 'pervCamp' ? 'active' : ''
                  } ${!isDefaultRegion && 'd-none'}`}
                onClick={async () => {
                  if (bulkMessageData?.name !== '') {
                    let confirNew = await confirm(
                      'Are you sure you want to use saved campaign?',
                      optionsWithLabelChange
                    )

                    if (confirNew) {
                      setBulkMessageData(bulkMessageState)
                      setError({})
                      setActiveTab('pervCamp')
                    } else {
                      setActiveTab('newCamp')
                    }
                  } else {
                    setActiveTab('pervCamp')
                  }
                }}
                data-testid='btnSavedCampaigns'
                disabled={!isDefaultRegion}
              >
                Saved campaigns
              </button>
            </li>
          </ul>
          <div className='tab-content' id='myTabContent'>
            <div
              className={`tab-pane fade   ${activeTab == 'newCamp' ? 'show active' : ''} `}
              id='Newcampaign'
              role='tabpanel'
              aria-labelledby='New-campaign-tab'
            >
              <label className='mb-2' data-testid='txtCampaignTitle'>
                Campaign title
              </label>
              <div className='mxw_474'>
                <input
                  type='text'
                  data-testid='inputNewCampaignTitle'
                  className='react-tagsinput-input form-control form-control-lg form-control-solid w-100'
                  placeholder='Catchy title'
                  value={bulkMessageData.name}
                  onChange={(e: any) => {
                    let errorData = { ...error }

                    delete errorData.name

                    setBulkMessageData({ ...bulkMessageData, name: e.target.value })
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        name: e.target.value,
                      })
                    )

                    e.target.value !== ''
                      ? setError(errorData)
                      : setError({ ...error, name: 'name is required' })
                  }}
                />
              </div>
            </div>
            <div
              className={`tab-pane fade   ${activeTab == 'pervCamp' ? 'show active' : ''} ${!isDefaultRegion && 'd-none'}`}
              id='Previously-campaigs'
              role='tabpanel'
              aria-labelledby='Previously-campaigs'
            >
              <label className='mb-2' data-testid='labelSavedCampaigns'>
                Saved campaigns
              </label>

              <Select
                data-testid='ddSavedCampaign'
                value={bulkMessageData?.previouslySendId}
                placeholder='Select saved campaign'
                className='mw-xl-75'
                options={SavedCampaginList()}
                onChange={handleSavedCampaign}
              />
            </div>

            {/* //////OUR TEMPLATE//// */}
            <div
              className='tab-pane fade'
              id='Templates'
              role='tabpanel'
              aria-labelledby='Templates-tab'
            >
              <label className='mb-2'>Saved campaigns</label>
              <div className='d-flex align-items-start align-items-sm-center flex-column flex-sm-row'>
                <Select
                  value={bulkMessageData?.selectedTemplate}
                  onChange={handleSelectTemplate}
                  name='selector'
                  className='form-select bg-light-primary border-0 mw-xl-75 py-4'
                  options={templates?.items?.map((key: any) => ({
                    value: key?.name,
                    label: key?.name,
                  }))}
                />
                {/* <select
                  name='selector'
                  className='form-select bg-light-primary border-0 mw-xl-75 py-4'
                  onChange={handleSelectTemplate}
                >
                  <option value='1'>Select your template</option>
                  {templates?.map((key: any) => (
                    <option value={key?.name}>{key?.name}</option>
                  ))}
                </select> */}
                <button
                  onClick={() => setShowTemplate(!showTemplate)}
                  className='btn btn-primary msg-primary-btn text-nowrap p-4 px-7 mx-2'
                >
                  {`${showTemplate ? 'Hide our templates' : 'view our templates'} `}
                </button>
              </div>

              {showTemplate && (
                <div className='row template-sidebar-main'>
                  <div className='col-md-3 col-sm-4'>
                    <div className='template-sidebar'>
                      <div className='sidebar-block'>
                        <span className='title'>TYPE</span>
                        <ul>
                          <li
                            className='cursor-pointer'
                            onClick={() => setFilterName({ type: 'MMS' })}
                          >
                            MMS
                          </li>
                          <li
                            className='cursor-pointer'
                            onClick={() => setFilterName({ type: 'SMS' })}
                          >
                            SMS
                          </li>
                        </ul>
                      </div>

                      <div className='sidebar-block'>
                        <span className='title'>Category</span>
                        <ul>
                          {Category?.data?.category?.map((val: any, i: number) => (
                            <li
                              key={i}
                              className='row cursor-pointer'
                              onClick={() => setFilterName({ category: val?._id })}
                            >
                              <p className='col-10'>{val._id?.toUpperCase()}</p>
                              <span className='col-2'>{val?.total}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className='sidebar-block'>
                        <span className='title'>Industry</span>
                        <ul>
                          {Category?.data?.industry?.map((val: any, i: number) => (
                            <li
                              key={i}
                              className='row cursor-pointer'
                              onClick={() => setFilterName({ industry: val?._id })}
                            >
                              <p className='col-10'>{val._id?.toUpperCase()}</p>
                              <span className='col-2'>{val?.total}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-9 col-sm-8 ps-sm-10'>
                    <div className='template-block-main'>
                      <div className='template-block-title'>
                        <strong>
                          {filterName?.type || filterName?.industry || filterName?.category}
                        </strong>
                      </div>

                      <div className='row mx-n6 template-row'>
                        {MMSList?.length !== 0 && (
                          <>
                            {/* <h1 className='fw-bolder d-flex justify-content-start'>MMS</h1> */}
                            {Templates?.map((key: any, index: number) => {
                              return (
                                <React.Fragment key={index}>
                                  {key.type == 'MMS' && (
                                    <div key={key?._id} className='col-md-6 px-6'>
                                      <div className='template-block'>
                                        <img
                                          alt='Logo'
                                          src={key?.media}
                                          className='w-100 border-10 rounded  img-fluid'
                                        />
                                        <div className='template-block-desc'>
                                          <ul className='type'>
                                            {key?.tags?.map((tags: any, i: number) => (
                                              <a
                                                key={i}
                                                className={'badge badge-light-primary me-2 mb-2'}
                                              >
                                                {tags}
                                              </a>
                                            ))}
                                          </ul>
                                          <p className='user-title'>{key?.message}</p>
                                          <div className='preview'>
                                            <div className='pre-total'>
                                              <img
                                                src={toAbsoluteUrl('/media/mobile/calandar.svg')}
                                                alt='Calander'
                                              />
                                              {key?.message?.split('')?.length}
                                            </div>
                                            <div className='pre-btn'>
                                              <span
                                                onClick={() => {
                                                  setVisble(true)
                                                  setTemplateData(key)
                                                }}
                                                className='btn btn-primary msg-primary-btn'
                                              >
                                                Preview
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}

                        {SMSList?.length !== 0 && (
                          <>
                            <h1 className='fw-bolder d-flex justify-content-start'>SMS</h1>
                            {Templates?.map((key: any, index: number) => {
                              return (
                                <React.Fragment key={index}>
                                  {key.type == 'SMS' && (
                                    <div key={key?._id} className='col-md-6 px-6'>
                                      <div className='template-block'>
                                        <div className='template-block-desc'>
                                          <ul className='type'>
                                            {key?.tags?.map((tags: any, i: number) => (
                                              <a
                                                key={i}
                                                className={'badge badge-light-primary me-2 mb-2'}
                                              >
                                                {tags}
                                              </a>
                                            ))}
                                          </ul>
                                          <p className='user-title'>{key?.message}</p>
                                          <div className='preview'>
                                            <div className='pre-total'>
                                              <img
                                                src='/Cellcast-reactjs/media/mobile/calandar.svg'
                                                alt='preview'
                                              />
                                              {key?.content?.split('')?.length}
                                            </div>
                                            <div className='pre-btn'>
                                              <span
                                                onClick={() => {
                                                  setVisble(true)
                                                  setTemplateData(key)
                                                }}
                                                className='btn btn-primary msg-primary-btn'
                                              >
                                                Preview
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GettingStarted
